export default "__VITE_ASSET__CWSjZm8m__"